import {Avatar, Tag} from "antd";
import config from "@/config";
import {MdEmail} from "react-icons/md";
import {PhoneCall} from "lucide-react";

const ProfileCardMB = ({profile}) => {
    return (
        <div className={"w-full container mx-auto py-3 px-4"}>
            <div className={"grid grid-cols-1 gap-2"}>
                <Avatar className={"size-24 mx-auto"} src={config.webConfig.defaultAvatar}/>
                <div className={"text-center"}>
                    <h2 className={"text-xl font-semibold"}>{profile.name}</h2>
                    <p className={"text-md text-gray-600"}>{profile.job}</p>
                </div>
                <div className={"grid grid-cols-1 gap-2"}>
                    <div>
                        <h3 className={"font-semibold"}>Giới thiệu</h3>
                        <p className={"text-sm text-gray-600"}>{profile.about}</p>
                    </div>
                    <div>
                        <h3 className={"font-semibold"}>Vị trí</h3>
                        <p className={"text-sm text-gray-600"}>{profile.location}</p>
                    </div>
                    <div>
                        <h3 className={"font-semibold"}>Liên hệ</h3>
                        <p className={"text-sm text-gray-600 flex items-center gap-4"}>
                            <PhoneCall size={20}/> {profile.phone}
                        </p>
                        <p className={"text-sm text-gray-600 flex items-center gap-4"}>
                            <MdEmail size={20}/>{profile.email}
                        </p>
                    </div>
                    <div className={"justify-center mx-auto items-center"}>
                        <button
                            className="mt-4 bg-gradient-to-r from-blue-500 to-cyan-500 hover:from-blue-700 hover:to-cyan-700 text-white font-bold py-3 px-8 rounded-full transition duration-300">
                            Sửa thông tin
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ProfileCardMB;